// @flow
import {Component} from 'react';
import {Image, Platform, StatusBar, StyleSheet, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Text} from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import {
  FullButton,
  GradientPage,
  SecondaryFullButton,
  TertiaryFullButton,
} from '../../components/common';
import theme from '../../theme-config';
import {getActivationInitialRouteName} from '../../lib/navigation';
import * as Navigation from '../../lib/navigation.js';

type Props = {
  areCheatCodesEnabled: Boolean,
  canAccessStyleGuide: Boolean,
  resetCustomerData: Function,
  setGodfatherExternalId: Function,
  setOrderStateForUuid: Function,
};

class WelcomeScreen extends Component<Props> {
  goToSignIn = () => {
    this.props.setGodfatherExternalId(null);
    Navigation.navigate('login');
  };

  goToRequiredToSignUpPage = () => {
    this.props.resetCustomerData();
    this.props.setGodfatherExternalId(null);
    Navigation.navigate('requiredToSignUp');
  };

  goToActivate = () => {
    this.props.resetCustomerData();
    this.props.setGodfatherExternalId(null);
    Navigation.navigate(getActivationInitialRouteName());
  };

  goToStyleGuide = () => {
    if (this.props.canAccessStyleGuide || this.props.areCheatCodesEnabled) {
      Navigation.navigate('styleGuide');
    }
  };

  render() {
    const styles = getStyles();
    const edgesByOs = Platform.OS === 'android' ? ['top', 'left', 'right'] : ['top', 'left', 'right']

    return (
        <SafeAreaView style={{flex: 1}} edges={edgesByOs}>
          <GradientPage
            noNavBar
            backgroundImage={theme.circularStrokesBackgroundImage}>
            <StatusBar
              barStyle={theme.signUpStatusBarStyle}
              backgroundColor={theme.androidStatusBarColor}
            />
            {Platform.OS !== 'web' && (
              <View style={styles.loginContainer}>
                <Text style={styles.loginText}>
                  {I18n.t('WelcomeScreen.alreadyHaveAccount')}
                </Text>
                <TertiaryFullButton
                  style={styles.loginButton}
                  onPress={this.goToSignIn}
                  onLongPress={this.goToStyleGuide}
                  text={I18n.t('login')}
                  testID="loginButton"
                />
              </View>
            )}
            <View style={styles.titles}>
              <Image
                source={theme.logoImage}
                style={styles.logo}
                resizeMode="contain"
              />
              <Text style={styles.subtitle}>
                {I18n.t('WelcomeScreen.subtitle')}
              </Text>
            </View>
            <View style={styles.buttons}>
              <FullButton
                style={styles.bigButton}
                textStyle={styles.activateButton}
                onPress={this.goToRequiredToSignUpPage}
                text={I18n.t('signUp')}
                testID={'orderSimButton'}
              />
              {Platform.OS !== 'web' && (
                <SecondaryFullButton
                  textStyle={styles.activateButton}
                  onPress={this.goToActivate}
                  text={I18n.t('activate')}
                  testID={'activateSimButton'}
                />
              )}
            </View>
          </GradientPage>
        </SafeAreaView>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    bigButton: {
      marginBottom: 16,
      paddingHorizontal: 10,
      paddingVertical: 10,
    },
    activateButton: {
      fontSize: Platform.OS === 'ios' ? 21 : 21,
    },
    buttons: {
      flex: 1,
      marginHorizontal: 17,
    },
    loginButton: {
      paddingLeft: 10,
      paddingRight: 10,
    },
    loginContainer: {
      alignItems: 'flex-end',
      flex: 1,
      margin: '2%',
    },
    loginText: {
      marginBottom: '2%',
    },
    logo: {
      height: '35%',
      marginBottom: '30%',
    },
    subtitle: {
      color: theme.welcomeScreenTextColor,
      fontSize: Platform.OS === 'ios' ? 18 : 18,
      textAlign: 'center',
    },
    title: {
      color: theme.welcomeScreenTextColor,
      fontSize: 26,
      fontWeight: 'bold',
      marginHorizontal: 40,
      textAlign: 'center',
    },
    titles: {
      alignItems: 'center',
      backgroundColor: 'transparent',
      flex: 2,
      justifyContent: 'flex-end',
      marginBottom: 20,
    },
  });

export default WelcomeScreen;
